export const SESSION_COMPANY_CHANGE                     = 'company-change'
export const SESSION_COMPANY_PROFILE_CHANGE             = 'company:profile:changed'

export const SESSION_PROJECTS_CHANGED                   = 'SESSION_PROJECTS_CHANGED'
export const SESSION_PROJECT_CHANGE                     = 'session-project:change'
export const SESSION_PROJECT_NEW                        = 'session-project:new'
export const SESSION_PROJECT_DELETE                     = 'session-project:delete'
export const SESSION_PROJECT_SETTINGS_CHANGE            = 'project-settings:changed'
export const BUS_TREE_CHANGE                            = 'tree-change'

export const SESSION_PROJECT_USERS_CHANGED              = 'session-project-users:change'
export const SESSION_CUSTOM_VIEWS_CHANGE                = 'gd.session.customViews:change'

export const BUS_APP_CONTROLS_RERENDER                  = 'app-controls:reRender'

export const SESSION_STARRED_CHANGED                    = 'SESSION_STARRED_CHANGED'
export const SESSION_COMPANY_SETTINGS_CHANGED           = 'company-settings:reset'


export const BUS_SESSION_CUSTOM_FIELDS_CHANGE           = 'session:custom-fields:change'


export const SESSION_PINS_CHANGED                       = 'SESSION_PINS_CHANGED'

export const BUS_TOP_PANEL_DISABLE_EXTENSIONS           = 'top-panel-disable-extensions'
export const BUS_TOP_PANEL_ENABLE_EXTENSIONS            = 'top-panel-enable-extensions'

export const BUS_SETTINGS_MANAGER_CONFIG_CHANGED        = 'settings-manager:configChanged'
export const BUS_PROJECT_SHARE_VIEW_UPDATE_TOP_PANEL    = 'project-share-view:updateTopPanel'

export const BUS_TABLE_PORTFOLIO_ADD_PROJECT            = 'table-module:portfolioAddProject'
export const BUS_TABLE_PORTFOLIO_REMOVE_PROJECT         = 'table-module:portfolioRemoveProject'

export const BUS_USER_CHANGE                            = 'gd.user:change'
export const BUS_PROJECT_SYSTEM_TYPE_CHANGED            = 'project:onConverted'

export const BUS_TOGGLE_SUBMENU                         = 'toggle-submenu'